// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3nH-0","resendInfoText":"OnGoingPaymentBox_resendInfoText__28u8C"};